import "../Academics/ProgrammeCard.scss";

const ProgrammeCard = ({ bgImage, course }) => {

    return (
        <div className="programmeCardParent">
            <div className="programmeCardImage" style={{ backgroundImage: `url(${bgImage})` }}></div>
            <div className="programmeCardContent">
                <h3>{course}</h3>
            </div>
        </div>
    );
}

export default ProgrammeCard;
